export default __webpack_public_path__ + "static/media/person-on-phone.c3f2f4e5.jpg";